import styled from "styled-components";
import { LogOutStyle } from "../SignOut/style";

export const NavWrapper = styled.div`
  flex-shrink: 0;
`;

export const DesktopNavWrapper = styled.div`
  background: white;
  width: 88px;
  position: relative;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ChannelLabel = styled.div`
  color: red;
  font-weight: bold;
  margin-left: auto;
  margin-right: auto;
  margin-top: -8px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.1;
  min-height: ${props => (props.$withSubLabel ? "30px" : "auto")};
  font-size: ${props => (props.$mobile ? "13px" : "14px")};

  @media (max-width: 768px) {
    margin-top: 0;
    padding: 4px 0 8px;
    font-size: 12px;
  }
`;

export const ChannelBadgeSubLabel = styled.span`
  font-size: 10px;
  font-weight: 600;
  margin-top: 2px;
  max-width: 84px;
  overflow-wrap: anywhere;
`;

export const LogoImage = styled.div`
  width: 100%;
  height: 60px;
  padding: 3px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-grow: 0;
  flex-shrink: 0;
`;

export const LogoImg = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  object-position: center;
  display: block;
`;

export const StyledNavContainer = styled.nav`
  position: fixed;
  background: ${props => (props.$specialDeployment ? "var(--grey-4)" : "var(--background-color-white)")};
  color: var(--grey-1);
  height: 100vh;
  top: 0;
  left: 0;
  width: 120px;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);
  z-index: 20;
  overflow: visible;
  padding-bottom: 20px;
  transition: transform 0.2s ease-out;

  @media (min-width: 769px) {
    width: 88px;
    padding-top: 0;
    padding-bottom: 0;
    overflow-y: auto;
  }

  @media (max-width: 768px) {
    width: 120px;
    height: 100dvh;
    padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));
    overflow-y: auto;
    overscroll-behavior: contain;
    transform: translateX(${props => (props.$mobileOpen ? "0" : "-100%")});
    visibility: ${props => (props.$mobileOpen ? "visible" : "hidden")};
    pointer-events: ${props => (props.$mobileOpen ? "auto" : "none")};
    box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);
  }
`;

export const NavFooter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(4px, 0.8vh, 10px);
  padding: clamp(1px, 0.8vh, 8px) 0 calc(clamp(4px, 1vh, 16px) + env(safe-area-inset-bottom, 0px));
`;

export const ReportIssueStyle = styled(LogOutStyle)`
  font-weight: normal;

  svg {
    width: 18px;
    color: var(--grey-3);
  }

  p {
    color: var(--grey-3);
  }

  &:hover svg,
  &:hover p {
    color: var(--key-color-2);
  }

  &:focus-visible {
    outline: 1px solid black;
  }
`;

export const NavFooterSpacer = styled.div`
  flex: 1 1 auto;
  min-height: clamp(2px, 1.5vh, 20px);
`;

export const NavFooterItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(2px, 0.5vh, 4px);

  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-decoration: none;
  }

  p {
    margin: 0;
    font-size: 12px;
    line-height: 1.2;
    color: var(--grey-2);
  }
`;

// NOTE: the spacing between items scales with the viewport height, between a minimum and a
// maximum, instead of jumping at a height breakpoint. Surplus height goes to NavFooterSpacer,
// which keeps the menu top-aligned and the footer at the bottom.
export const StyledNavList = styled.ul`
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: clamp(2px, 2.5vh, 24px);
  padding-top: clamp(8px, 2vh, 40px);
`;

export const StyledNavListItem = styled.li`
  width: 100%;
  text-align: center;
  transition: 0.4s;
  padding: clamp(4px, 1vh, 10px) 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;

  @media (min-width: 769px) {
    border-left: ${props => (props.selected ? "4px solid var(--key-color-2)" : "4px solid transparent")};
  }

  button {
    background-color: transparent;
    border: 0;
    color: ${props => (props.selected ? "var(--key-color-2)" : "var(--grey-3)")};

    &:focus-visible {
      outline: 1px solid black;
    }

    svg {
      transition: 0.4s;
      width: 30px;
      color: inherit;
    }
  }

  button {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: clamp(2px, 0.5vh, 4px);

    p {
      position: static;
      width: auto;
      height: auto;
      margin: 0;
      overflow: visible;
      clip: auto;
      white-space: normal;
      border-width: 0;
      font-size: 12px;
      line-height: 1.2;
    }
  }
`;

export const UserInfoContainer = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  text-align: center;
  font-weight: bold;
  padding: 10px;
  position: relative;
  width: 62px;
  height: 62px;
  box-sizing: border-box;

  h5 {
    span {
      font-size: 12px;
      margin-top: 5px;
      color: var(--key-color-2);
    }
  }

  h1 {
    pointer-events: none;
    position: absolute;
    inset: 10px;
    width: 42px;
    height: 42px;
    vertical-align: middle;
    line-height: 1.1;
    border-radius: 50%;
    background: var(--key-color-2-gradient);
    font-size: 20px;
    font-weight: bold;
    color: white;
    margin: 0;
    transition: opacity 0.4s;
  }

  svg {
    position: absolute;
    right: 7px;
    bottom: 7px;
    width: 20px;
    height: 20px;
    color: var(--key-color-2);
    transition: opacity 0.4s;
    opacity: 1;
  }

  @media (max-width: 768px) {
    width: 56px;
    height: 56px;
    padding: 8px;

    h1 {
      inset: 8px;
      width: 40px;
      height: 40px;
      font-size: 18px;
    }

    svg {
      right: 6px;
      bottom: 6px;
      width: 18px;
      height: 18px;
    }
  }
`;

export const HamburgerMenuButton = styled.div`
  position: fixed;
  left: calc(16px + env(safe-area-inset-left, 0px));
  bottom: calc(16px + env(safe-area-inset-bottom, 0px));
  background: var(--key-color-2);
  border: none;
  outline: none;
  color: white;
  width: min-content;
  border-radius: 50%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto;
  z-index: 2147483646;
  display: ${props => (props.$hidden ? "none" : "flex")};

  svg {
    width: 32px;
    height: 32px;
    color: white;
  }

  @media (min-width: 769px) {
    display: none;
  }
`;

export const SliderBlanket = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(153, 153, 153, 0.5);
  animation: 0.2s ease-out 0s 1 normal none running eMLfYp;
  z-index: 19;
  pointer-events: auto;
`;
